import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs, defaultColDef } from './definitions-config';

function WebsiteTable({ rowData }) {
  return (
    <div className='ag-theme-alpine' style={{ height: '85vh', width: '100%' }}>
      <AgGridReact
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        pagination={true}
        paginationPageSize={10}
        paginationAutoPageSize={true}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        rowHeight={50}
      />
    </div>
  );
}

export default WebsiteTable;
